// Web-app install state, shared by InstallPrompt and the account menu.
// Imported first thing in index.js so Chrome's one-time "beforeinstallprompt" event is never missed.
const KEY = "tns_install";
const listeners = new Set();
let deferred = null; // Chrome / Edge / Samsung: the browser's own install dialog, kept for our button

const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
const isIPad = /Macintosh/.test(ua) && typeof navigator !== "undefined" && navigator.maxTouchPoints > 1;
const isIOS = /iPhone|iPod|iPad/.test(ua) || isIPad;
const inAppBrowser = /FBAN|FBAV|Instagram|Line\/|WhatsApp|Snapchat|TikTok|; wv\)/.test(ua);
const macSafari =
  /Macintosh/.test(ua) && !isIPad && /Version\/(\d+)/.test(ua) && Number(ua.match(/Version\/(\d+)/)[1]) >= 17 &&
  /Safari\//.test(ua) && !/Chrome|Chromium|CriOS|Edg|Firefox|FxiOS|OPR/.test(ua);

export const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; }
};
export const write = (patch) => {
  try { localStorage.setItem(KEY, JSON.stringify({ ...read(), ...patch })); } catch (e) { /* private mode: fine */ }
  listeners.forEach((fn) => fn());
};

export const isStandalone = () =>
  (typeof window !== "undefined" && window.matchMedia &&
    (window.matchMedia("(display-mode: standalone)").matches || window.matchMedia("(display-mode: window-controls-overlay)").matches)) ||
  (typeof navigator !== "undefined" && navigator.standalone === true);

// "chrome" = real install button, "ios" / "mac" = how-to steps, null = nothing to offer here.
export const kind = () => {
  if (isStandalone() || read().installed) return null;
  if (deferred) return "chrome";
  if (inAppBrowser) return null;
  if (isIOS) return "ios";
  if (macSafari) return "mac";
  return null;
};
export const iosBrowser = () => (/CriOS/.test(ua) ? "chrome" : /FxiOS|EdgiOS/.test(ua) ? "other" : "safari");
export const isPhone = () => isIOS ? !isIPad && !/iPad/.test(ua) : /Android|Mobi/.test(ua);

export const promptInstall = async () => {
  if (!deferred) return "unavailable";
  const ev = deferred;
  deferred = null;
  ev.prompt();
  const choice = await ev.userChoice.catch(() => ({ outcome: "dismissed" }));
  if (choice.outcome === "accepted") write({ installed: true });
  listeners.forEach((fn) => fn());
  return choice.outcome;
};

export const subscribe = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };

export const track = (action) => {
  try { if (window.gtag) window.gtag("event", "app_install_prompt", { action, prompt_kind: kind() || "none" }); } catch (e) { /* ignore */ }
};

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault(); // we show our own prompt at a good moment instead of Chrome's mini bar
    deferred = e;
    if (read().installed) write({ installed: false }); // Chrome only offers this when the app is not installed (e.g. removed since)
    listeners.forEach((fn) => fn());
  });
  window.addEventListener("appinstalled", () => { deferred = null; write({ installed: true }); track("installed"); });
  if (isStandalone()) write({ installed: true });
  // Chrome on Android / desktop can also tell us when this web app is already installed.
  if (navigator.getInstalledRelatedApps) {
    navigator.getInstalledRelatedApps().then((apps) => { if (apps && apps.length) write({ installed: true }); }).catch(() => {});
  }
  if ("serviceWorker" in navigator && window.location.protocol === "https:") {
    window.addEventListener("load", () => { navigator.serviceWorker.register("/sw.js").catch(() => {}); });
  }
}
